import { render } from "./HelloWorld.vue?vue&type=template&id=0495e2ba&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=0495e2ba&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0495e2ba"

export default script